import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="grid grid-cols-1 gap-10 px-4 py-12 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-heart-3-fill text-lg" />
            </span>
            <span className="font-heading text-xl tracking-wide">红桃视频在线观看</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
            红桃视频在线观看聚合电影、电视剧、综艺等优质影视资源信息，
            为影视爱好者提供便捷的搜索、分类浏览与详情查询体验。平台内容均为信息展示，
            不提供在线播放服务。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-medium text-background-50">影视分类</h4>
          <ul className="space-y-2 text-sm text-background-200">
            <li>
              <Link to="/category/movie" className="transition-colors hover:text-accent-300">
                电影
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="transition-colors hover:text-accent-300">
                电视剧
              </Link>
            </li>
            <li>
              <Link to="/category/variety" className="transition-colors hover:text-accent-300">
                综艺
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-accent-300">
                搜索影视
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-medium text-background-50">关于我们</h4>
          <ul className="space-y-2 text-sm text-background-200">
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-300">
                品牌介绍
              </Link>
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-line text-sm" />
              </span>
              contact@hongtaotv.demo
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-customer-service-2-line text-sm" />
              </span>
              工作日 9:00 - 18:00
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="flex flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-8">
          <p>© {year} 红桃视频在线观看 · 本站内容仅供影视信息展示与交流</p>
          <p>演示站点 · 未接入真实播放与数据接口</p>
        </div>
      </div>
    </footer>
  );
}